import React from 'react'
// TODO move ui
// import { Section, Button } from '@brainstud/schiphol-vtc-ui'
import { QuestionCard, QuizProgress } from '../../shared'
import Help from '../../shared/quizhelp'
import styles from './Question.module.css'

const Section = props => props.children
const Button = props => props.children || props.label

const HelpModal = props => {
  const Component = Help[props.type]
  return <Component {...props} />
}

const Question = props => (
  <Section reset>
    <div className={styles.base}>
      <QuizProgress
        value={props.progressbar}
        current={props.currentQIndex}
        total={props.quizProgress.totalQuestions} />

      {/* <div className={styles.help}>
        <Button
          onClick={() => props.modal.open('quiz-help', { component: <HelpModal {...props} /> })}
          label="Spelregels" icon="help" iconSize="small" minimal />
      </div> */}

      <div className={styles.questions}>
        {!props.isFirstQuestion &&
          <div className={styles.cardPrev}>
            <QuestionCard
              correct={props.prevQuestionStatus === 'correct'}
              wrong={props.prevQuestionStatus === 'wrong'} />
          </div>
        }

        <div className={styles.card}>
          <QuestionCard {...props} />
        </div>

        {!props.isLastQuestion &&
          <div className={styles.cardNext}>
            <QuestionCard
              correct={props.nextQuestionStatus === 'correct'}
              wrong={props.nextQuestionStatus === 'wrong'} />
          </div>
        }
      </div>
    </div>
  </Section>
)

export default Question
